import React, { useState } from 'react';
import { Table, Form, Container } from 'react-bootstrap';

type InsuranceCategory = {
  category: string;
  description: string;
  score: number | '';
  notes: string;
};

const initialData: InsuranceCategory[] = [
  { category: 'Health Insurance', description: 'Covers doctor visits, hospital stays, prescriptions, and preventive care', score: '', notes: '' },
  { category: 'Dental Insurance', description: 'Includes cleanings, fillings, orthodontics', score: '', notes: '' },
  { category: 'Vision Insurance', description: 'Covers eye exams, glasses, contact lenses', score: '', notes: '' },
  { category: 'Life Insurance (Parents)', description: "Protects family finances in the event of a parent's death", score: '', notes: '' },
  { category: 'Life Insurance (Children)', description: 'Optional coverage for child funeral costs or future conversion', score: '', notes: '' },
  { category: 'Disability Insurance', description: 'Replaces income if a working family member becomes disabled', score: '', notes: '' },
  { category: 'Homeowners/Renters Insurance', description: 'Covers dwelling, personal property, and liability', score: '', notes: '' },
  { category: 'Auto Insurance', description: 'Liability, collision, and comprehensive coverage for all family vehicles', score: '', notes: '' },
  { category: 'Umbrella Insurance', description: 'Additional liability protection beyond auto/home policies', score: '', notes: '' },
  { category: 'Long-Term Care Insurance', description: 'Covers nursing home or in-home care in later years', score: '', notes: '' },
  { category: 'Travel Insurance', description: 'Protects against trip cancellations, lost baggage, medical emergencies abroad', score: '', notes: '' },
  { category: 'Pet Insurance', description: 'Covers vet bills, surgeries, and medications for pets', score: '', notes: '' },
  { category: 'College/Student Insurance', description: 'Insurance for students away at college', score: '', notes: '' },
  { category: 'Cyber Liability Protection', description: 'Covers ID theft, online fraud, and device security', score: '', notes: '' },
  { category: 'Flood/Earthquake Insurance', description: 'Optional add-on for geographic risk areas', score: '', notes: '' },
  { category: 'Business Insurance (if home-based)', description: 'Liability and property protection for home businesses', score: '', notes: '' },
  { category: 'Legal/Identity Protection Plan', description: 'Access to attorneys and ID theft restoration', score: '', notes: '' },
  { category: 'Health Savings Account (HSA) or FSA', description: 'Tax-advantaged savings for medical expenses', score: '', notes: '' },
  { category: 'Dependent Care FSA', description: 'Tax savings for childcare or adult dependent care', score: '', notes: '' },
  { category: 'Estate Planning & Insurance Review', description: 'Updated wills, trusts, beneficiary designations', score: '', notes: '' }
];

const FamilyInsuranceScoreCard: React.FC = () => {
  const [data, setData] = useState<InsuranceCategory[]>(initialData);

  const handleScoreChange = (index: number, value: string) => {
    const updated = [...data];
    updated[index].score = value === '' ? '' : Number(value);
    setData(updated);
  };

  const handleNotesChange = (index: number, value: string) => {
    const updated = [...data];
    updated[index].notes = value;
    setData(updated);
  };

  return (
    <Container className="my-4">
      <h2 className="mb-4 text-center">🛡️ Family Insurance Score Card</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Category</th>
            <th>Description</th>
            <th>Score (1-5)</th>
            <th>Notes / Action Items</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx}>
              <td>{item.category}</td>
              <td>{item.description}</td>
              <td>
                <Form.Select
                  value={item.score}
                  onChange={(e) => handleScoreChange(idx, e.target.value)}
                >
                  <option value="">--</option>
                  {[1, 2, 3, 4, 5].map((val) => (
                    <option key={val} value={val}>{val}</option>
                  ))}
                </Form.Select>
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={item.notes}
                  onChange={(e) => handleNotesChange(idx, e.target.value)}
                  placeholder="Add notes or action items"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default FamilyInsuranceScoreCard;
